import React from 'react';
import { useNotificationContext } from '../contexts/NotificationContext';
import { createSampleNotifications } from '../utils/notificationHelpers';
import { Box, Button, Typography, Paper, Grid } from '@mui/material';

const TestNotifications = () => {
  const { addNotification, clearAllNotifications } = useNotificationContext();

  const handleAddSampleNotifications = () => {
    const sampleNotifications = createSampleNotifications();
    
    // Adicionar notificações com delay
    sampleNotifications.forEach((notification, index) => {
      setTimeout(() => {
        addNotification(
          notification.type,
          notification.title,
          notification.message,
          notification.roomId
        );
      }, index * 1000); // 1 segundo entre cada notificação
    });
  };

  const handleAddSingleNotification = (type, title, message) => {
    addNotification(type, title, message);
  };

  return (
    <Box sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom>
        Teste do Sistema de Notificações
      </Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Adicionar Notificações de Exemplo
        </Typography>
        <Grid container spacing={2}>
          <Grid item>
            <Button 
              variant="contained" 
              onClick={handleAddSampleNotifications}
              color="primary"
            >
              Adicionar Todas as Notificações de Exemplo
            </Button>
          </Grid>
          <Grid item>
            <Button 
              variant="outlined" 
              onClick={clearAllNotifications}
              color="secondary"
            >
              Limpar Todas as Notificações
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Adicionar Notificações Individuais
        </Typography>
        <Grid container spacing={2}>
          <Grid item>
            <Button 
              variant="outlined" 
              onClick={() => handleAddSingleNotification(
                'ANNOUNCEMENT',
                'Matheus Di Carlos Torres enviou um novo comunicado',
                'Novo comunicado sobre atualizações do sistema'
              )}
            >
              Comunicado
            </Button>
          </Grid>
          <Grid item>
            <Button 
              variant="outlined" 
              onClick={() => handleAddSingleNotification(
                'COINS_EARNED',
                'Você ganhou moedas pelo seu acesso de hoje!',
                'Parabéns! Você ganhou 50 moedas por acessar o sistema hoje.'
              )}
            >
              Moedas
            </Button>
          </Grid>
          <Grid item>
            <Button 
              variant="outlined" 
              onClick={() => handleAddSingleNotification(
                'CELEBRATION',
                'Flávia Regina Alexandre comentou em uma celebração com você!',
                'Flávia deixou um comentário em uma celebração que você participou.'
              )}
            >
              Celebração
            </Button>
          </Grid>
          <Grid item>
            <Button 
              variant="outlined" 
              onClick={() => handleAddSingleNotification(
                'FEEDBACK',
                'Alexandre Ramires da Silva enviou um feedback para você',
                'Alexandre compartilhou um feedback sobre seu trabalho.'
              )}
            >
              Feedback
            </Button>
          </Grid>
          <Grid item>
            <Button 
              variant="outlined" 
              onClick={() => handleAddSingleNotification(
                'SCHEDULED_MEETING',
                'Você tem 1:1 agendada pra hoje',
                'Revise seus tópicos clicando aqui :)'
              )}
            >
              Reunião
            </Button>
          </Grid>
          <Grid item>
            <Button 
              variant="outlined" 
              onClick={() => handleAddSingleNotification(
                'NEW_MESSAGE',
                'Nova mensagem do cliente',
                'Olá, preciso de ajuda com meu pedido #12345'
              )}
            >
              Nova Mensagem
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Instruções
        </Typography>
        <Typography variant="body2" paragraph>
          1. Clique nos botões acima para adicionar notificações
        </Typography>
        <Typography variant="body2" paragraph>
          2. Observe o badge de notificações na barra lateral
        </Typography>
        <Typography variant="body2" paragraph>
          3. Clique no badge para ver as notificações recentes
        </Typography>
        <Typography variant="body2" paragraph>
          4. Clique no badge de notificações na barra lateral
        </Typography>
        <Typography variant="body2">
          5. Teste os filtros e funcionalidades no menu de notificações
        </Typography>
      </Paper>
    </Box>
  );
};

export default TestNotifications;
